<template>
    <div class="list">
        <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
            <el-form-item label="选择搜索类型:">
                <el-select v-model="listQuery.search_type" style="width:200px" clearable>
                    <el-option label="页面类型" value="1"></el-option>
                    <el-option label="页面url" value="2"></el-option>
                    <el-option label="标题" value="3"></el-option>
                    <el-option label="描述" value="4"></el-option>
                    <el-option label="关键词" value="5"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="listQuery.keyword_search" clearable style="width: 300px" class="name-input" placeholder="请输入关键词" />
            </el-form-item>

            <el-form-item class="add">
                <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="listLoading" :data="list" border style="width: 100%" size="small">
            <el-table-column prop="name" label="页面类型" align="center" />
            <el-table-column prop="url" label="页面URL" align="center" />
            <el-table-column prop="title" label="页面标题" align="center" />
            <el-table-column prop="dec" label="描述" align="center" />
            <el-table-column prop="key_word" label="关键词" align="center" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="hasEdit" type="primary" size="small" @click="showDialog(scope)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>

        <common-dialog :title="dialogTitle" :dialog-visible="dialogVisible" :show-btns="showBtns">
            <el-form>

                <el-form-item label="页面类型:" label-width="80px">
                    <span>{{ baseInfo.name }}</span>
                </el-form-item>

                <el-form-item label="页面URL:" label-width="80px">
                    <span>{{ baseInfo.url }}</span>
                </el-form-item>

                <el-form-item label="页面标题:" label-width="80px">
                    <el-input v-model="baseInfo.title" placeholder="页面标题"></el-input>
                </el-form-item>

                <el-form-item label="描述:" label-width="80px">
                    <el-input v-model="baseInfo.dec" placeholder="描述"></el-input>
                </el-form-item>

                <el-form-item label="关键词:" label-width="80px">
                    <el-input v-model="baseInfo.key_word" placeholder="关键词"></el-input>
                </el-form-item>

                <el-form-item class="button_wrap">
                    <el-button type="primary" @click="dialogConfirmClick">保存</el-button>
                    <el-button @click="dialogVisible=false">返回</el-button>
                </el-form-item>
            </el-form>
        </common-dialog>
    </div>
</template>
<script>
import { getSettingSEO, editSettingSEO, settingSEODetail } from '@/api/seo';
import Pagination from '@/components/Pagination';
import CommonDialog from '@/components/CommonDialog';
import operations from '../../mixins/operations';

export default {
    components: { Pagination, CommonDialog },
    mixins: [operations],
    data() {
        return {
            baseInfo: {
                title: "",
                dec: "",
                key_word: ""
            },
            id: "",
            showBtns: false,
            dialogTitle: "",
            dialogType: "",
            list: [],
            dialogVisible: false,
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10
            },
            listLoading: false
        };
    },
    computed: {
        hasEdit() {
            return this.operations.includes('编辑基础设置');
        }
    },
    async mounted() {
        this.getList();
    },
    methods: {
        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getSettingSEO(params);
            this.listLoading = false;
            this.total = total;
            this.list = data;
        },

        showDialog(scope) {
            this.baseInfo = Object.assign({}, scope.row);
            this.id = scope.row.id
            this.dialogVisible = true
        },

        async dialogConfirmClick() {
            const { title, dec, key_word } = this.baseInfo;
            if (!title) return this.$notify.error({ title: '请输入页面标题' });
            if (!dec) return this.$notify.error({ title: '请输入页面描述' });
            if (!key_word) return this.$notify.error({ title: '请输入页面关键字' });
            const res = await editSettingSEO(this.id, this.baseInfo);
            if (res == true) {
                this.getList();
                this.$notify({ title: '编辑成功', type: 'success' });
                this.dialogVisible = false;
            } else {
                this.$notify.error({ title: '操作失败' });
            }
        }
    }
};
</script>

<style lang="less" scoped>
    .list{
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }
        .el-form-item:last-child{
            margin-bottom: 0;
        }
    }
</style>
